/** Trang chủ */
const dashboard = {
  dashboard: {
    actions: {
      view: true,
      exceedDailyAvg: false,
    },
    numericalOrder: 1,
    description: 'Giám sát hệ thống',
  },

  dashboard_2: {
    actions: {
      view: true,
    },
    numericalOrder: 2,
    description: 'Giám sát tổng quan',
  },

  utilityDashboard: {
    actions: {
      view: true
    },
    numericalOrder: 3,
    description: 'Bảng điều khiển',
  }
}

/** 2 - Khai thác dữ liệu */
const dataMining = {
  monitoring: {
    actions: {
      view: true,
      control: false,
      camera: false,
      chart: false,
      map: false,
      images: false,
      infoStation: false,
      reviewStation: false,
    },
    numericalOrder: 3,
    description: 'Giám sát trực tuyến',
  },

  monitorByList: {
    actions: {
      view: true,
    },
    numericalOrder: 4,
    description: 'Giám sát danh sách',
  },

  map: {
    actions: {
      view: true,
    },
    numericalOrder: 5,
    description: 'Bản đồ',
  },

  camera: {
    actions: {
      view: true,
    },
    numericalOrder: 6,
    description: 'Camera',
  },

  chart: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 7,
    description: 'Phân tích dữ liệu',
  },

  dataSearch: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 8,
    description: 'Tra cứu dữ liệu',
  },

  avgSearch: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 9,
    description: 'Dữ liệu trung bình',
  },
}

/** 3 - Dự báo định kỳ */
const periodicForecast = {
  periodicalStation: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false
    },
    numericalOrder: 10,
    description: "Trạm quan trắc dự báo định kỳ"
  },
  periodicalImportStation: {
    actions: {
      view: true,
    },
    numericalOrder: 11,
    description: "Nhập dữ liệu dự báo định kỳ"
  },
  periodicalSeachData: {
    actions: {
      view: true,
      export: false
    },
    numericalOrder: 12,
    description: "Tra cứu dữ liệu dự báo định kỳ"
  },
}

/** 4 - Quan trắc định kỳ */
const stationPeriodic = {
  stationFix: {
    actions: {
      view: true,
      create: true,
      edit: true,
      delete: true,
    },
    numericalOrder: 13,
    description: 'Quản lý điểm quan trắc',
  },
  stationFixPhase: {
    actions: {
      view: true,
      create: true,
      edit: true,
      delete: true,
    },
    numericalOrder: 14,
    description: 'Quản lý báo cáo định kỳ',
  },
  stationFixInput: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false,
    },
    numericalOrder: 15,
    description: 'Dữ liệu quan trắc',
  },
  stationFixData: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 16,
    description: 'Tra cứu dữ liệu điểm quan trắc',
  },
  stationFixMap: {
    actions: {
      view: true,
    },
    numericalOrder: 17,
    description: 'Bản đồ điểm quan trắc',
  },
}

/** 5 - Chia sẻ dữ liệu */
const dataSharing = {
  qaqcConfig: {
    actions: {
      view: true,
      publicStation: false,
    },
    numericalOrder: 18,
    description: 'Cấu hình chia sẻ dữ liệu',
  },
  ftpTransfer: {
    actions: {
      view: true,
      isTransfer: false,
      updateFTP: false,
    },
    numericalOrder: 19,
    description: 'Cấu hình truyền FTP',
  },
  shareAPI: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false,
    },
    numericalOrder: 20,
    description: 'Chia sẻ API',
  },
}

/** 6 - Phí môi trường */
const billing = {
  billingReport: {
    actions: {
      view: true,
      create: true,
      export: false,
    },
    numericalOrder: 21,
    description: 'Báo cáo phí',
  },
  billingConfig: {
    actions: {
      view: true,
      create: true,
      edit: true,
      delete: true,
    },
    numericalOrder: 22,
    description: 'Cấu hình tính phí',
  },
}

/** 7 - Sự cố */
const incident = {
  incidentManagement: {
    actions: {
      view: true,
      create: true,
      edit: true,
      delete: true,
      export: true,
    },
    numericalOrder: 23,
    description: 'Quản lý sự cố',
  },
  incidentConfigProperties: {
    actions: {
      view: true,
      create: true,
      edit: true,
      delete: true,
    },
    numericalOrder: 24,
    description: 'Cấu hình thuộc tính',
  },
}

/** 8 - Cảnh báo */
const alarm = {
  alarm_management: {
    actions: {
      view: true,
      config: false,
      delete: false,
    },
    numericalOrder: 25,
    name: 'Cài đặt cảnh báo',
  },
  alarm_history: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 26,
    name: 'Lịch sử cảnh báo',
  },
}

/** 9 - Báo cáo */
const report = {
  tiLeDuLieuThuDuoc: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 27,
    description: 'Tỉ lệ dữ liệu thu được',
  },
  tb24H: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 28,
    description: 'Trung bình 24 giờ',
  },
  tb1H: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 29,
    description: 'Trung bình 1 giờ',
  },
  tb1HMax: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 30,
    description: 'Trung bình 1h Max',
  },
  tb8HMax: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 31,
    description: 'Trung bình 8h Max',
  },

  tileDuLieuVuotNguong: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 32,
    description: 'Tỉ lệ dữ liệu vượt ngưỡng',
  },
  tinhTrangDuLieu: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 33,
    description: 'Tình trạng dữ liệu',
  },
  reportExceed: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 34,
    description: 'Dữ liệu vượt ngưỡng',
  },
  reportFlow: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 35,
    description: 'Lưu lượng phát thải',
  },
}

/** 10 - Nâng cao */
const advanced = {
  aqiMap: {
    actions: {
      view: true,
    },
    numericalOrder: 36,
    description: 'Bản đồ AQI',
  },
  aqiReport: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 37,
    description: 'Báo cáo AQI',
  },
  wqiMap: {
    actions: {
      view: true,
    },
    numericalOrder: 38,
    description: 'Bản đồ WQI',
  },
  wqiGio: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 39,
    description: 'WQI - giờ',
  },
  wqiNgay: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 40,
    description: 'WQI - ngày',
  },
  wqiPeriodic: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 41,
    description: 'WQI - đinh kì',
  },
  configWQI: {
    actions: {
      view: true,
    },
    numericalOrder: 42,
    description: 'Cấu hình tính WQI, AQI',
  },
  cauHinhTinhToanAQI: {
    actions: {
      view: true,
    },
    numericalOrder: 43,
    description: 'Cấu hình tính toán AQI',
  },
  cauHinhTinhToanWQI: { 
    actions: {
      view: true,
    },
    numericalOrder: 44,
    description: 'Cấu hình tính toán WQI',
  },
  configCalculate: {
    actions: {
      view: true,
    },
    numericalOrder: 45,
    description: 'Cấu hình tính toán',
  },
}

/** 11 - Config */
const config = {
  stationAuto: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false,
      connect: false,
      linkBilling: false
    },
    numericalOrder: 46,
    description: 'Trạm quan trắc',
  },
  // cauHinhKetNoi: {
  //   actions: {
  //     view: true,
  //     fileMapping: false,
  //   },
  //   numericalOrder: 47,
  //   description: 'Cấu hình kết nối',
  // },
  cauHinhLayMau: {
    actions: {
      view: true,
    },
    numericalOrder: 48,
    description: 'Cấu hình lấy mẫu',
  },
  cauHinhCamera: {
    actions: {
      view: true,
      updateSelectStation: false,
      create: false,
      edit: false,
      delete: false,
    },
    numericalOrder: 49,
    description: 'Cấu hình Camera',
  },
  config_color_noti: {
    actions: {
      view: true,
    },
    numericalOrder: 50,
    description: 'Cấu hình màu cảnh báo',
  },

  measuring: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false,
    },
    numericalOrder: 51,
    description: 'Thông số quan trắc',
  },

  stationType: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false,
    },
    numericalOrder: 52,
    description: 'Loại trạm',
  },
  province: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false,
    },
    numericalOrder: 53,
    description: 'Đơn vị quản lý',
  },
  qcvn: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false,
    },
    numericalOrder: 54,
    description: 'Quy chuẩn',
  },
  kiemDuyetDuLieu: {
    actions: {
      view: true,
      export: false,
    },
    numericalOrder: 55,
    description: 'Kiểm duyệt dữ liệu',
  },
  service_config: {
    actions: {
      view: true,
      setup: false,
    },
    numericalOrder: 56,
    name: 'Cấu hình dịch vụ',
  },
  role: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false,
    },
    numericalOrder: 57,
    description: 'Nhóm quyền',
  },
  user: {
    actions: {
      view: true,
      create: false,
      edit: false,
      delete: false,
      role: false,
      enableAccount: false,
    },
    numericalOrder: 58,
    description: 'Tài khoản',
  },
  language: {
    actions: {
      view: true,
    },
    numericalOrder: 59,
    description: 'Cấu hình ngôn ngữ',
  },
  xem_Nhat_ky: {
    actions: {
      view: true,
    },
    numericalOrder: 60,
    description: 'Xem nhật ký',
  },
  connectionManagement: {
    actions: {
      view: true,
    },
    numericalOrder: 61,
    description: 'Quản lý kết nối',
  },
  controlInterface: {
    actions: {
      view: true,
    },
    numericalOrder: 62,
    description: 'Giao diện điều khiển',
  },
  // connection: {
  //   actions: {
  //     view: true,
  //   },
  //   numericalOrder: 61,
  //   description: 'Quản lý kết nối',
  // },
}

export default {
  ...dashboard,
  ...dataMining,
  ...periodicForecast,
  ...stationPeriodic,
  ...dataSharing,
  ...billing,
  ...incident,
  ...alarm,
  ...report,
  ...advanced,
  ...config,
}

// export default {
//   xuLyDuLieu_config: {
//     actions: {
//       view: true,
//     },
//     numericalOrder: 8,
//     description: "Xử lý dữ liệu - Cấu hình"
//   },
//   soLanMatKetNoi: {
//     actions: {
//       view: true,
//       export: false
//     },
//     numericalOrder: 19,
//     description: "Số lần mất kết nối"
//   },
//   cauHinhGuiCanhBao: {
//     actions: {
//       view: true,
//     },
//     numericalOrder: 33,
//     description: "Cấu hình gửi cảnh báo"
//   },
//   mobile_dashboard: {
//     actions: {
//       view: true,
//       statistics_device: false,
//       statistics_exceeded_avgDay: false
//     },
//     numericalOrder: 44,
//     name: "Trang chủ Mobile"
//   },
// };




// WEBPACK FOOTER //
// ./src/constants/menu.js